import React, { useState, useEffect } from 'react';
import { toJS } from 'mobx'
import { observer } from "mobx-react-lite"
import { useNavigate } from "react-router-dom";
import {
  Box, TextField,
  Button, MenuItem,
  InputLabel,
  FormControl,
  Select,
  Typography,
  FormGroup,
  FormControlLabel, 
  Switch,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useOrderStore } from 'store/RootProvider'
import CommonConst from 'constants/CommonConst';
import * as EzDateUtils from 'utils/EzDateUtils'

/*
{
    "payInfoId": "aaa@naver.com0123456789;_20210125123442",
    "ezCompanyId": "aaa@naver.com",
    "userId": "aaa@naver.com",
    "payItemType": "EP01",
    "payItemName": "30일이용권",
    "payItemPrice": 11000,
    "payRequestDate": "20210125123442",
    "payResultMsg": "정상처리되었습니다.",
    "payResultCode": "0000",
    "paymethod": "Card",
    "tid": "StdpayCARDINIpayTest20210125123521490597",
    "applnum": "43081882",
    "appldate": "20210125",
    "appltime": "123522",
    "custemail": null,
    "buyername": "우리회사",
    "buyertel": null,
    "cardNum": "465887*********5",
    "cardInterest": "0",
    "cardQuota": "00",
    "cardCode": "14",
    "cardPrtcCode": "1",
    "regState": "PR02",
    "id": "0"
}
*/


/**
 * DataGrid 상단 헤더 컬럼을 
 * 정의 합니다. 
 */
const columns = [
  {
    field: 'ezCompanyId',
    headerName: '몰아이디',
    width: 200
  },
  {
    field: 'payItemName',
    headerName: '구매상품',
    sortable: false,
    width: 130,
  },
  {
    field: 'payItemPrice',
    headerName: '구매금액',
    sortable: false,
    width: 80,
  },
  {
    field: 'payResultMsg',
    headerName: '결제결과',
    sortable: false,
    width: 130,
  },
  {
    field: 'compName',
    headerName: '상호명',
    width: 150,
    editable: true,
  },
  {
    field: 'ceoName',
    headerName: '대표자',
    width: 80,
    editable: true,
  },
  {
    field: 'compSsn',
    headerName: '사업자번호',
    type: 'number',
    width: 110,
    editable: true,
  },
  {
    field: 'buyername',
    headerName: '구매자명',
    sortable: false,
    width: 130,
  },
  {
    field: 'buyertel',
    headerName: '구매자연락처',
    sortable: false,
    width: 130,
  },
  
  {
    field: 'applnum',
    headerName: '승인번호',
    sortable: false,
    width: 130,
  },
  {
    field: 'cardNum',
    headerName: '결제정보',
    sortable: false,
    width: 160,
  },
  {
    field: 'payRequestDate',
    headerName: '결제일자',
    sortable: false,
    width: 160,
    valueGetter: (params) => {
      return (EzDateUtils.dateFormatting(params.row.payRequestDate));
    }
  },
  {
    field: 'regState',
    headerName: '등록상태',
    sortable: false,
    width: 160,
  },
];

/**
 * 화면 상단의 검색 
 * 폼을 렌더링 합니다. 
 * @param {*} searchField  : 검색조건
 * @param {*} searchKeyword  : 검색어
 * @param {*} setSearchKeyWord  : 검색어 설정 CallBack
 * @param {*} setSearchField  : 검색조건 설정 CallBack
 * @param {*} doSearch  : 검색 요청 CallBack
 * @param {*} isViewDetailBtnDisable  : 상세 보기 버튼 비활성화 구준 
 * @param {*} doViewDeatail  : 상세 보기 요청 CallBack
 * @returns 
 */
const SearchForm = ({
  searchField,
  searchKeyword,
  setSearchKeyWord,
  setSearchField,
  regState,
  onRegStateChanged,
  doSearch,
  isViewDetailBtnDisable,
  doViewDeatail,
}) => {

  return (
    <Box
      component="form"
      onSubmit={doSearch}
      sx={{
        mb: 5, mt: 2, border: 0,
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <FormControl sx={{ width: 150, }}>
        <InputLabel id="demo-simple-select-label">검색조건</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={searchField}
          label="검색조건"
          onChange={(event) => {
            setSearchField(event.target.value);
          }}
        >
          <MenuItem value={CommonConst.MEMBER_SEARCH_FIELD_COMPANY_ID}>회사아이디</MenuItem>
          <MenuItem value={CommonConst.MEMBER_SEARCH_FIELD_COMPANY_NAME}>상호명</MenuItem>
          <MenuItem value={CommonConst.MEMBER_SEARCH_FIELD_SSN}>사업자번호</MenuItem>
          <MenuItem value={CommonConst.MEMBER_SEARCH_FIELD_TELNO}>전화번호</MenuItem>
          <MenuItem value={CommonConst.MEMBER_SEARCH_FIELD_FAXNO}>팩스번호</MenuItem>
        </Select>
      </FormControl>
      <TextField
        id="standard-basic"
        label="검색어를 입력하세요"
        variant="filled"
        value={searchKeyword}
        sx={{ flex: 1, ml: 2 }}
        onChange={(event) => {
          setSearchKeyWord(event.target.value);
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            setSearchKeyWord(e.target.value);
            doSearch();
          }
        }}
      />
      <FormGroup
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ml:3,
        }}
      >
        <FormControlLabel
          control={
            <Switch checked={regState} 
              onChange={(event) => {
              onRegStateChanged(event?.target.checked);
            }} name="gilad" />
          }
          label="결제완료"
        />
      </FormGroup>
      <Button
        variant="outlined"
        sx={{ ml: 2 }}
        onClick={doSearch}
      >
        검색
      </Button>
      <Button
        variant="outlined"
        sx={{ ml: 2 }}
        disabled={isViewDetailBtnDisable}
        onClick={doViewDeatail}
      >
        상세 보기
      </Button>
    </Box>
  );
}

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const MemberContents = ({
  data,
  setSelectedRows
}) => {
  const [pageSize, setPageSize] = useState(10);
  return (
    <DataGrid
      autoHeight={true}
      rows={data}
      columns={columns}
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      rowsPerPageOptions={[5, 10, 20]}
      checkboxSelection
      disableSelectionOnClick
      onSelectionModelChange={(ids) => {
        const selectedIDs = new Set(ids);
        const selectedRowData = data.filter((row) =>
          selectedIDs.has(row.id.toString())
        );
        setSelectedRows(selectedRowData);
      }}
    />
  );
}
/*
 * Module - OrderList.js
 *
 * Description : 주문 목록 화면입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Thu Jun 23 2022
 * Copyright (c) 2022 Renewhouse corp
 */
const OrderList = observer(() => {
  const navigate = useNavigate();
  const orderStore = useOrderStore();

  const [searchField, setSearchField] = useState('');
  const [searchKeyword, setSearchKeyWord] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [regState, setRegState] = useState(true);

  useEffect(() => {
    doSearch();
  }, []);

  /**
   * 회원 검색을 스토어에 요청 합니다. 
   */
  const doSearch = async () => {
    try {
      let param = {};
      param.searchField = searchField;
      param.searchKeyword = searchKeyword;
      param.pageNo = 1;
      param.pageAmount = 10;
      param.regState = regState;

      let result = await orderStore.doSearch(param);
      console.log(result);
    }
    catch (e) {
      console.log("1111", e);
    }
  }

  /**
   * 상세 보기 화면으로 이동 합니다. 
   */
  const moveToDetail = () => {
    navigate("/orders/detail", { state: selectedRows });
  }



  return (
    <>
      <Typography variant="h5" color="text.primary">결제 목록</Typography>
      <SearchForm
        searchField={searchField}
        searchKeyword={searchKeyword}
        setSearchField={setSearchField}
        setSearchKeyWord={setSearchKeyWord}
        regState={regState}
        onRegStateChanged={setRegState}
        doSearch={doSearch}
        isViewDetailBtnDisable={(selectedRows?.length == 1) ? false : true}
        doViewDeatail={moveToDetail}
      />
      <MemberContents
        data={toJS(orderStore.lst)}
        setSelectedRows={setSelectedRows}
      />
    </>
  );
})

export default OrderList;

